/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import React from 'react';

import { Copy } from 'src/common/ui/components';
import { PatientsQuery } from 'src/generated/gql/graphql';

const careTeamMap = {
  prescriber: 'CL',
  peer: 'PC',
  coordinator: 'CA',
  caseManager: 'CM',
};

type keyofCareTeamMap = keyof typeof careTeamMap;

export const CareTeam = ({ item }: { item: PatientsQuery['items'][number] }) => {
  if (!item) return null;

  const careTeam = Object.keys(careTeamMap)
    .map((key: keyofCareTeamMap) => {
      const member = item[key];
      if (!member) return null;
      return {
        key,
        label: careTeamMap[key],
        name: `${member.firstName} ${member.lastName}`,
      };
    })
    .filter((member): member is NonNullable<typeof member> => Boolean(member));

  return (
    <ul
      css={css`
        display: flex;
        flex-direction: column;
        list-style: none;
        padding: 0;
        margin: 0;
      `}
    >
      {careTeam.map(({ key, label, name }) => (
        <li key={key}>
          <Copy variant="body2">
            {label}: {name}
          </Copy>
        </li>
      ))}
    </ul>
  );
};
